import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NormeSpaOrdinarioFieldValidators } from './validators/norme-spa-ordinario.field-validators';
import { NormeSpaOrdinarioWarningService } from './warnings/norme-spa-ordinario.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [NormeSpaOrdinarioWarningService, NormeSpaOrdinarioFieldValidators],
})
export class NormeSpaOrdinarioFormModule {}
